"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POST_AVAILABILITY = exports.SECTION_TYPES = void 0;
exports.SECTION_TYPES = {
    APARTMENT_INFO: 'apartment_info',
    BUILDING_INFO: 'building_info',
    MORTGAGE_INFO: 'mortgage_info',
    SIMILAR_PROPERTY_INFO: 'similar_property',
    DEVELOPER_INFO: 'developer_info',
    APARTMENTS_INFO: 'apartments_info',
    HOUSE_INFO: 'house',
    COMMERCIAL_INFO: 'commercial',
};
exports.POST_AVAILABILITY = {
    SALE: 'sale',
    SOLD: 'sold',
    BOOKED: 'booked',
};
